import React, { useEffect } from "react";
import { RewardInterface } from "src/store/mine_craft/rewardsSlice";

import FileDropzone from "src/componets/FileDropzone";
import { Button, Form, Input, InputNumber } from "antd";
import { DollarOutlined, FieldNumberOutlined } from "@ant-design/icons";

interface propsInterface {
  params?: RewardInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();
  const [showBtn, setShowBtn] = React.useState(!params?.id);
  const toValue = Form.useWatch('to', form);
  const fromValue = Form.useWatch('from', form);

  useEffect(() => {
    if(params?.id) {
      setShowBtn(false);
    }

    form.resetFields();
  }, [params, form]);

  function onValuesChange() {
    setShowBtn(true);
  }

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form v-reward-form'
      initialValues={params}
      onValuesChange={onValuesChange}
    >
      <Form.Item name='challenge_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <div className='v-reward--left'>
        <div className='v-group-dropzone'>
          <FileDropzone name='thumbnail' label='' preview={params?.thumbnail_url} />
        </div>

        {
          showBtn &&
            <Form.Item>
              <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
        }
      </div>

      <div className='v-reward--right'>
        <Form.Item name='title'>
          <Input placeholder='Title' bordered={false} />
        </Form.Item>

        <Form.Item name='coins'>
          <InputNumber
            min={0}
            step={5}
            placeholder='5'
            bordered={false}
            prefix={<DollarOutlined />}
          />
        </Form.Item>

        <div className='v-reward--places'>
          <Form.Item name='from'>
            <InputNumber
              min={1}
              placeholder='1'
              bordered={false}
              prefix={<FieldNumberOutlined />}
            />
          </Form.Item>

          <Form.Item name='to' className={!!toValue ? '' : 'o-opacity'}>
            <InputNumber
              min={(fromValue || 1) + 1}
              placeholder='-'
              bordered={false}
              prefix={<FieldNumberOutlined />}
            />
          </Form.Item>
        </div>
      </div>
    </Form>
  )
}

export default _Form;
